import React, { useState } from 'react';
import { XIcon, ChevronLeftIcon, ChevronRightIcon, CameraIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
interface GalleryImage {
  src: string;
  alt: string;
  year: string;
}
const galleryImages: GalleryImage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/otRrPD6r1SggevYonLeU1s/KS_00495_www.ks-foto.lv.jpg',
  alt: 'Braucējs lec no stāva nogāzes meža trasē',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/69PYqqwBgi3ipmPCF6AbY7/KS_02054_www.ks-foto.lv.jpg',
  alt: 'Braucējs šķērso ūdens šķērsli meža trasē',
  year: '2024'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hiWFwUejaLqZnE5Se5pyau/KS_00135_www.ks-foto.lv.jpg',
  alt: 'Braucējs veic tehnisko sekciju ar baļķiem',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1ZQJxZRt4kVLZ7SdQJgkfz/KS_00095_www.ks-foto.lv.jpg',
  alt: 'Braucējs lec pār betona šķērsli Red Bull arkas priekšā',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qRm1dc5wui8F38KXcfQzX1/KS_00028_www.ks-foto.lv.jpg',
  alt: 'Sacensību trase ar Nibigear karogiem un sponsoru banneriem',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/me5jHH1UVSVzto18YNqiiZ/KS_00212_www.ks-foto.lv.jpg',
  alt: 'Braucēji šķērso riepas šķērsli sacensībās',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rvEZHGnMb3AbLrHKUMakMN/KS_00188_www.ks-foto.lv.jpg',
  alt: 'Braucējs lec pār koka šķērsli',
  year: '2025'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jzHQtW64bN5yuVp7bUprNu/KS_00685_www.ks-foto.lv.jpg',
  alt: 'Braucēji cīnās meža trasē Motomaniac Hard Enduro 2025',
  year: '2025'
}];
export function PhotoGallery() {
  const {
    t
  } = useLanguage();
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  function openLightbox(index: number) {
    setLightboxIndex(index);
  }
  function closeLightbox() {
    setLightboxIndex(null);
  }
  function goNext() {
    if (lightboxIndex !== null) {
      setLightboxIndex((lightboxIndex + 1) % galleryImages.length);
    }
  }
  function goPrev() {
    if (lightboxIndex !== null) {
      setLightboxIndex((lightboxIndex - 1 + galleryImages.length) % galleryImages.length);
    }
  }
  return <section id="gallery" className="w-full bg-black py-20 md:py-28 px-4" data-id="element-186">
      <div className="max-w-7xl mx-auto" data-id="element-187">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-188">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-189">
            {t('gallery.reliveAction')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-190">
            {t('gallery.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-191">
            {t('gallery.subtitle')}
          </p>
        </div>

        {/* Google Photo Album Links */}
        <div className="mb-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-192">
          <a href="https://drive.google.com/drive/folders/1chq19cT1aU50q4agpHpIznI6mqyB53Ap?fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnkeZCyOWb14XFPWHQnW_FIBXjJEIMYWWZG5PJKqY0BP1_D01t1T9gTrPERuQ_aem_f1rrFjcveuYz-bV9Uo04KA$0" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-neutral-900 border border-neutral-700 hover:border-orange-500/50 rounded-xl text-white font-semibold transition-all hover:scale-105 group" data-id="element-193">
            <CameraIcon className="h-5 w-5 text-orange-500 group-hover:scale-110 transition-transform" data-id="element-194" />
            <div className="text-left" data-id="element-195">
              <span className="block text-sm uppercase tracking-wider" data-id="element-196">
                {t('gallery.photos2025')}
              </span>
              <span className="block text-xs text-gray-500" data-id="element-197">
                Google Photos albums
              </span>
            </div>
            <svg className="h-4 w-4 text-gray-500 group-hover:text-orange-500 transition-colors ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-198">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" data-id="element-199" />
            </svg>
          </a>
          <a href="https://drive.google.com/drive/folders/1OwVfW0RkeMcmVdJ_pQ5s37m9rGrDADD5" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-neutral-900 border border-neutral-700 hover:border-orange-500/50 rounded-xl text-white font-semibold transition-all hover:scale-105 group" data-id="element-200">
            <CameraIcon className="h-5 w-5 text-orange-500 group-hover:scale-110 transition-transform" data-id="element-201" />
            <div className="text-left" data-id="element-202">
              <span className="block text-sm uppercase tracking-wider" data-id="element-203">
                {t('gallery.photos2024')}
              </span>
              <span className="block text-xs text-gray-500" data-id="element-204">
                Google Drive albums
              </span>
            </div>
            <svg className="h-4 w-4 text-gray-500 group-hover:text-orange-500 transition-colors ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-205">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" data-id="element-206" />
            </svg>
          </a>
        </div>

        {/* Gallery Grid - Masonry-like layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-207">
          {/* Image 1 - Large */}
          <div className="col-span-2 row-span-2 relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(0)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(0)} aria-label={`View photo: ${galleryImages[0].alt}`} data-id="element-208">
            <img src={galleryImages[0].src} alt={galleryImages[0].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-209" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-210">
              <CameraIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-211" />
            </div>
            <div className="absolute bottom-3 left-3 px-2 py-1 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-212">
              {galleryImages[0].year}
            </div>
          </div>

          {/* Image 2 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(1)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(1)} aria-label={`View photo: ${galleryImages[1].alt}`} data-id="element-213">
            <img src={galleryImages[1].src} alt={galleryImages[1].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-214" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-215">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-216" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-217">
              {galleryImages[1].year}
            </div>
          </div>

          {/* Image 3 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(2)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(2)} aria-label={`View photo: ${galleryImages[2].alt}`} data-id="element-218">
            <img src={galleryImages[2].src} alt={galleryImages[2].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-219" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-220">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-221" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-222">
              {galleryImages[2].year}
            </div>
          </div>

          {/* Image 4 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(3)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(3)} aria-label={`View photo: ${galleryImages[3].alt}`} data-id="element-223">
            <img src={galleryImages[3].src} alt={galleryImages[3].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-224" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-225">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-226" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-227">
              {galleryImages[3].year}
            </div>
          </div>

          {/* Image 5 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(4)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(4)} aria-label={`View photo: ${galleryImages[4].alt}`} data-id="element-228">
            <img src={galleryImages[4].src} alt={galleryImages[4].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-229" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-230">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-231" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-232">
              {galleryImages[4].year}
            </div>
          </div>

          {/* Image 6 - Wide */}
          <div className="col-span-2 relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(5)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(5)} aria-label={`View photo: ${galleryImages[5].alt}`} data-id="element-233">
            <img src={galleryImages[5].src} alt={galleryImages[5].alt} className="w-full h-full object-cover aspect-[2/1] group-hover:scale-105 transition-transform duration-500" data-id="element-234" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-235">
              <CameraIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-236" />
            </div>
            <div className="absolute bottom-3 left-3 px-2 py-1 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-237">
              {galleryImages[5].year}
            </div>
          </div>

          {/* Image 7 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(6)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(6)} aria-label={`View photo: ${galleryImages[6].alt}`} data-id="element-238">
            <img src={galleryImages[6].src} alt={galleryImages[6].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-239" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-240">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-241" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-242">
              {galleryImages[6].year}
            </div>
          </div>

          {/* Image 8 */}
          <div className="relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(7)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && openLightbox(7)} aria-label={`View photo: ${galleryImages[7].alt}`} data-id="element-243">
            <img src={galleryImages[7].src} alt={galleryImages[7].alt} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" data-id="element-244" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-245">
              <CameraIcon className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-246" />
            </div>
            <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-black/60 rounded text-xs text-gray-300 font-semibold" data-id="element-247">
              {galleryImages[7].year}
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" onClick={closeLightbox} role="dialog" aria-modal="true" aria-label="Photo lightbox" data-id="element-248">
          <button onClick={closeLightbox} className="absolute top-4 right-4 p-2 text-white hover:text-orange-500 transition-colors z-10" aria-label="Close lightbox" data-id="element-249">
            <XIcon className="h-8 w-8" data-id="element-250" />
          </button>

          <button onClick={e => {
        e.stopPropagation();
        goPrev();
      }} className="absolute left-4 p-2 text-white hover:text-orange-500 transition-colors z-10" aria-label="Previous photo" data-id="element-251">
            <ChevronLeftIcon className="h-10 w-10" data-id="element-252" />
          </button>

          <button onClick={e => {
        e.stopPropagation();
        goNext();
      }} className="absolute right-4 p-2 text-white hover:text-orange-500 transition-colors z-10" aria-label="Next photo" data-id="element-253">
            <ChevronRightIcon className="h-10 w-10" data-id="element-254" />
          </button>

          <div className="max-w-5xl max-h-[85vh] px-16" onClick={e => e.stopPropagation()} data-id="element-255">
            <img src={galleryImages[lightboxIndex].src} alt={galleryImages[lightboxIndex].alt} className="max-w-full max-h-[80vh] object-contain rounded-lg" data-id="element-256" />
            <p className="text-center text-gray-400 text-sm mt-4" data-id="element-257">
              {galleryImages[lightboxIndex].alt} —{' '}
              {galleryImages[lightboxIndex].year}
            </p>
          </div>
        </div>}
    </section>;
}